export default "__VITE_ASSET__9d978d50__"